// Country and currency selection is handled by Shopify localization forms.

document.addEventListener("DOMContentLoaded", function () {
    const variantRadios = document.querySelectorAll('input[name="Print"]');
    const modalOpener = document.querySelector(".product__modal-opener");
    const trustedBadgePrintValues = ["None", "Classic"];
    const trustedBadgeMessages = [
        "Trusted by 10,000 Yogis",
        "UK's Best Sustainable Yoga Mat",
        "Trusted by Yoga Teachers",
        "Premium Portuguese Cork"
    ];
    let trustedBadgeIndex;
    let trustedBadgeIntervalId;
    let trustedBadgeTimeoutId;
    let trustedBadgeLabel;

    if (!modalOpener) {
        return;
    }

    trustedBadgeIndex = Math.floor(Math.random() * trustedBadgeMessages.length);
    trustedBadgeLabel = document.createElement("span");
    trustedBadgeLabel.className = "trusted-badge-label";
    modalOpener.appendChild(trustedBadgeLabel);

    function setTrustedBadgeMessage(index) {
        trustedBadgeLabel.classList.remove("is-visible");

        if (trustedBadgeTimeoutId) {
            window.clearTimeout(trustedBadgeTimeoutId);
        }

        trustedBadgeTimeoutId = window.setTimeout(function () {
            trustedBadgeLabel.textContent = trustedBadgeMessages[index];
            trustedBadgeLabel.classList.add("is-visible");
        }, 150);
    }

    function startTrustedBadgeRotation() {
        if (trustedBadgeIntervalId) {
            return;
        }

        trustedBadgeIntervalId = window.setInterval(function () {
            trustedBadgeIndex = (trustedBadgeIndex + 1) % trustedBadgeMessages.length;
            setTrustedBadgeMessage(trustedBadgeIndex);
        }, 10000);
    }

    function stopTrustedBadgeRotation() {
        if (!trustedBadgeIntervalId) {
            return;
        }

        window.clearInterval(trustedBadgeIntervalId);
        trustedBadgeIntervalId = null;
    }

    setTrustedBadgeMessage(trustedBadgeIndex);

    function updateCSS() {
        const selectedRadio = document.querySelector('input[name="Print"]:checked');

        if (selectedRadio && trustedBadgePrintValues.includes(selectedRadio.value)) {
            modalOpener.classList.add("show-trusted-badge");
            startTrustedBadgeRotation();
        } else {
            modalOpener.classList.remove("show-trusted-badge");
            stopTrustedBadgeRotation();
        }
    }

    variantRadios.forEach(radio => {
        radio.addEventListener("change", function () {
            setTimeout(updateCSS, 10); // Small delay to ensure proper detection
        });
    });

    // Initial check on page load
    updateCSS();
});

document.addEventListener("DOMContentLoaded", function () {
    const mobileQuery = window.matchMedia("(max-width: 767px)");

    function getStickyAtcOffset() {
        const stickyAtc = document.querySelector(".a-t-c-sticky.show-snav");

        if (!mobileQuery.matches || !stickyAtc) {
            return 0;
        }

        return Math.ceil(stickyAtc.getBoundingClientRect().height) + 8;
    }

    function offsetShopifyFormsTeaser() {
        const offset = getStickyAtcOffset();
        const formsEmbeds = document.querySelectorAll("[id^='app-embed-container-']");

        formsEmbeds.forEach(function (embed) {
            if (!embed.shadowRoot) {
                return;
            }

            const formRoot = embed.shadowRoot.querySelector("[data-form-root][data-layout='floating'][data-position^='bottom-']");

            if (!formRoot) {
                return;
            }

            const hasTeaser = formRoot.querySelector("button[aria-haspopup='dialog']");

            if (!hasTeaser) {
                return;
            }

            formRoot.style.bottom = offset ? offset + "px" : "";
        });
    }

    const formsOffsetObserver = new MutationObserver(offsetShopifyFormsTeaser);

    formsOffsetObserver.observe(document.documentElement, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ["class", "style", "data-current-step"]
    });

    window.addEventListener("scroll", offsetShopifyFormsTeaser, { passive: true });
    window.addEventListener("resize", offsetShopifyFormsTeaser);
    mobileQuery.addEventListener("change", offsetShopifyFormsTeaser);

    window.setTimeout(offsetShopifyFormsTeaser, 500);
    window.setTimeout(offsetShopifyFormsTeaser, 2000);
});
